<template>
    <router-view />
</template>

<script>
import { createMetaMixin } from 'quasar';
import { mapState } from 'vuex';

export default {
    created() {
        const loadUser = () => {
            this.$e.user.onLoadUser((user, callback) => {
                if (user != null && typeof user === 'object') {
                    this.$e.io.callMethod(
                        'existPersonFunctionManager',
                        {
                            'person_function-check': false,
                        },
                        {
                            success: (exist) => {
                                if (exist) {
                                    const role = this.$e.user.getRoles().ROLE_PERSON_FUNCTION_MANAGER;
                                    user.userRoleList.push({ role: role, userId: user.userId, roleName: 'Krajský/Okresný predseda', active: true });
                                    this.$e.user.setUser(user);
                                }
                                callback();
                            },
                            error: () => callback(),
                            afterError: () => {},
                        }
                    );
                } else {
                    callback();
                }
            });
            this.$e.user.load((user) => {
                if (user == null) {
                    this.$router.logout();
                } else {
                    this.$router.login();
                }
            });
        };

        this.$e.storageKey = 'enfis-';
        this.$e.io.callMethod('getApplicationInfo', null, {
            success: (info) => {
                this.title = process.env.VUE_APP_PROJECT_NAME + ': Administrácia';
                if (info.systemTypeCode === 'D') {
                    this.system = 'development';
                } else if (info.systemTypeCode === 'T') {
                    this.system = 'test';
                } else if (info.systemTypeCode === 'P') {
                    this.system = 'product';
                }

                let infoMessage = 'Názov aplikácie: ' + info.applicationName + '\n';
                infoMessage += 'Verzia aplikácie: ' + info.applicationVersion + '\n';
                infoMessage += 'Verzia databázy: ' + info.databaseVersion + '\n';
                infoMessage += 'Dátum vydania: ' + info.releaseDate + '\n';
                infoMessage += 'Typ systému: ' + info.systemTypeName;
                this.$store.commit('setAppInfo', infoMessage);
                this.$store.commit('setAppInfoObj', info);

                const storageKey = 'enfis-' + info.applicationName.toLowerCase() + '-';
                this.$e.storageKey = storageKey;
                this.$e.user.onSetUser((user) => {
                    this.$e.storageKey = storageKey + user.userAccount.login + '-';
                });
                loadUser();
            },
            error: (error) => {
                loadUser();
                return false;
            },
        });
    },
    data() {
        return {
            title: '',
            system: 'development',
        };
    },
    computed: {
        ...mapState(['appTitle']),
    },
    mixins: [
        createMetaMixin(function () {
            return {
                title: this.title + (!this.$e.is.empty(this.appTitle) ? ' | ' + this.appTitle : ''),
                bodyAttr: {
                    system: this.system,
                },
            };
        }),
    ],
};
</script>
